import React, { useEffect, useState, useMemo } from 'react';
import { View, Text } from 'react-native';
import { useSelector } from 'react-redux';
import { useCssStyle } from '../../customHook/getCssStyle';

const convertCToF = C => Math.round((C * 9) / 5 + 32);

const getForecastsWithinCurrentTime = (forecastData = []) => {
  const now = new Date();
  return forecastData.filter(item => {
    const from = new Date(item.fromDate);
    const to = new Date(item.toDate);
    return now >= from && now <= to;
  });
};

const WeatherWidget = () => {
  const getStyles = useCssStyle();
  const [todayData, setTodayData] = useState(null);

  const { weatherData } = useSelector(state => state.weather);

  const weatherInfo = useMemo(() => {
    return (
      weatherData?.weather?.find(w => w.city?.isDefault) || {
        city: {},
        forecast: [],
      }
    );
  }, [weatherData]);

  const forecast = useMemo(() => weatherInfo.forecast || [], [weatherInfo.forecast]);

  useEffect(() => {
    if (!forecast.length) return;
    const today = getForecastsWithinCurrentTime(forecast);
    if (today.length) setTodayData(today[0]);
  }, [forecast]);

  const cityName = weatherInfo.city?.name || '';
  const tempF = todayData ? convertCToF(todayData.temperature) : '--';
  const windSpeedName = todayData?.windSpeedName || '';
  const iconCode = String.fromCharCode(parseInt(todayData?.fontCode || 'f002', 16));

  return (
    <View style={getStyles(['weatherWidgetContainer'])} id='weatherWidgetContainer'>
      <View style={getStyles(['weatherWidgetDayContainer'])} id='weatherWidgetDayContainer'>

        {/* Weather icon — uses fontCode from forecast, fallback ☀ */}
        <Text style={getStyles(['weatherWidgetIcon'])} id='weatherWidgetIcon'>{iconCode}</Text>

        <View style={getStyles(['weatherWidgetTempContainer'])} id='weatherWidgetTempContainer'>
          <View style={getStyles(['weatherWidgetCurrentTemp'])} id='weatherWidgetCurrentTemp'>
            <Text style={getStyles(['weatherWidgetTempVal'])} id='weatherWidgetTempVal'>{tempF}</Text>
            <Text style={getStyles(['weatherWidgetTempSym'])} id='weatherWidgetTempSym'>{'\u00B0'}</Text>
            <Text style={getStyles(['weatherWidgetTempUnit'])} id='weatherWidgetTempUnit'>F</Text>
            {!!windSpeedName && (
              <Text style={getStyles(['weatherWidgetCondition'])} id='weatherWidgetCondition'> {windSpeedName}</Text>
            )}
          </View>

          {/* City name */}
          {!!cityName && (
            <Text style={getStyles(['weatherWidgetCityName'])} id='weatherWidgetCityName'>{cityName}</Text>
          )}
        </View>

      </View>
    </View>
  );
};

export default WeatherWidget;
